var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 23,
    viewBox: "0 0 127 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 2.33203L14.3322 8.07036L20.6663 8.9962L16.083 13.4604L17.1647 19.767L11.4997 16.7879L5.83467 19.767L6.91634 13.4604L2.33301 8.9962L8.66717 8.07036L11.4997 2.33203Z",
    fill: "#FFA033",
    stroke: "#FFA033",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 2.33203L40.3322 8.07036L46.6663 8.9962L42.083 13.4604L43.1647 19.767L37.4997 16.7879L31.8347 19.767L32.9163 13.4604L28.333 8.9962L34.6672 8.07036L37.4997 2.33203Z",
    fill: "#FFA033",
    stroke: "#FFA033",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4997 2.33203L66.3322 8.07036L72.6663 8.9962L68.083 13.4604L69.1647 19.767L63.4997 16.7879L57.8347 19.767L58.9163 13.4604L54.333 8.9962L60.6672 8.07036L63.4997 2.33203Z",
    fill: "#FFA033",
    stroke: "#FFA033",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4997 2.33203L92.3322 8.07036L98.6663 8.9962L94.083 13.4604L95.1647 19.767L89.4997 16.7879L83.8347 19.767L84.9163 13.4604L80.333 8.9962L86.6672 8.07036L89.4997 2.33203Z",
    fill: "#FFA033",
    stroke: "#FFA033",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 2.33203L118.332 8.07036L124.666 8.9962L120.083 13.4604L121.165 19.767L115.5 16.7879L109.835 19.767L110.916 13.4604L106.333 8.9962L112.667 8.07036L115.5 2.33203Z",
    stroke: "#FFA033",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.5677c5569a9fe986da34008f485842a3.svg";
export { ForwardRef as ReactComponent };